<template>
    <theme-provider :theme="theme" id="app">
        <router-view />

        <st-alert />
        <st-confirm />
    </theme-provider>
</template>

<script>
import { ThemeProvider } from "vue-styled-components";
import { default as theme } from "./styles/theme";

export default {
    name: "App",
    metaInfo: {
        title: "스쿨투게더 - 국민 가정통신문"
    },
    data: () => ({
        theme
    }),
    components: {
        ThemeProvider
    }
};
</script>